export const StarTransparent = ({ width = '20', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.39352 18.8821L3.52209 19.3205L4.39352 18.8821C4.36693 18.8293 4.35631 18.7648 4.36683 18.7007L5.19343 13.6643C5.31032 12.9521 5.08703 12.2158 4.57629 11.6956L1.07476 8.12881C1.03043 8.08366 1.00099 8.0172 1.00002 7.93817C0.999057 7.85912 1.02689 7.79125 1.0708 7.74417C1.10446 7.70809 1.14186 7.69121 1.17409 7.68632L6.01308 6.95152C6.74551 6.8403 7.35728 6.36341 7.66765 5.70622L9.83172 1.12398C9.86344 1.05681 9.90977 1.02326 9.94987 1.00905C9.98897 0.99519 10.0289 0.996449 10.0708 1.01809C10.1057 1.03609 10.1428 1.07042 10.1681 1.12398L12.3322 5.70622C12.6426 6.36341 13.2543 6.8403 13.9868 6.95152L18.8258 7.68632C18.9 7.69759 19.022 7.79647 18.9969 7.97641C18.988 8.04086 18.9597 8.09352 18.9251 8.12882L15.4236 11.6956C14.9128 12.2158 14.6895 12.9521 14.8064 13.6643L15.633 18.7007C15.6624 18.8798 15.5426 18.9839 15.4668 18.9974C15.4349 19.0032 15.4002 18.9985 15.3661 18.9797L11.038 16.6019C10.3897 16.2457 9.61017 16.2457 8.96189 16.6019L4.63376 18.9797C4.59158 19.0029 4.55155 19.005 4.51271 18.9923C4.47291 18.9794 4.4265 18.9477 4.39352 18.8821Z"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
};
